import { FC, memo, useCallback, useState } from 'react';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { Modal } from 'shared/ui/Modal';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';
import { ReactComponent as InfoIcon } from 'shared/assets/icons/InfoIcon.svg';
import { ReactComponent as CloseIcon } from 'shared/assets/icons/CloseIcon.svg';
import { getSpecialPromotionContent } from '../model/selectors/getSpecialPromotionContent';
import { useSpecialPromotionModal } from '../utils/hooks/useSpecialPromotionModal';
import { Button } from 'shared/ui/Button';
import { useAppTranslation } from 'app/config/i18Config/hooks';

export const SpecialPromotionModal: FC = memo(() => {
  const { isOpened, closeModal } = useSpecialPromotionModal();

  const { t } = useAppTranslation('booking');

  const [isInfoModalOpened, setInfoModalOpened] = useState(false);

  const openInfoModal = useCallback(() => {
    setInfoModalOpened(true);
  }, []);

  const closeInfoModal = useCallback(() => {
    setInfoModalOpened(false);
  }, []);

  const { isDesktop } = useScreenBreakpoints();

  const Content = useAppSelector(getSpecialPromotionContent);

  if (!Content) {
    return null;
  }

  return (
    <Modal
      width={1000}
      isOpen={isOpened}
      paddingLess
      transparent
      onClose={closeModal}
      headerItems={
        // <div className="absolute top-3.5 right-8 desktop:right-2">
        //   <div className="flex gap-2 desktop:gap-4 items-center">
        //     <div className="bg-white border border-black rounded-lg p-3">
        //       <InfoIcon
        //         width={isDesktop ? 30 : 20}
        //         height={isDesktop ? 30 : 20}
        //         onClick={openInfoModal}
        //         className="[&>path]:stroke-[#313131] cursor-pointer"
        //       />
        //     </div>
        //     <div className="bg-white border border-black rounded-lg py-2 px-2">
        //       <CloseIcon
        //         width={isDesktop ? 35 : 25}
        //         height={isDesktop ? 35 : 25}
        //         className="[&>path]:stroke-[#313131] cursor-pointer"
        //         onClick={closeModal}
        //       />
        //     </div>
        //   </div>
        // </div>
        <div className="absolute top-3.5 right-7">
          <div className="flex gap-2 desktop:gap-4 items-center">
            {/* <div className="bg-white border border-black rounded-lg p-3">
              <InfoIcon
                width={isDesktop ? 30 : 20}
                height={isDesktop ? 30 : 20}
                onClick={openInfoModal}
                className="[&>path]:stroke-[#313131] cursor-pointer"
              />
            </div> */}
            <div className="bg-white border border-black rounded-lg py-2 px-2">
              <CloseIcon
                width={isDesktop ? 35 : 25}
                height={isDesktop ? 35 : 25}
                className="[&>path]:stroke-[#313131] cursor-pointer"
                onClick={closeModal}
              />
            </div>
          </div>
        </div>
      }
      closeIcon={false}
    >
      <Content />
      <Modal isOpen={isInfoModalOpened} onClose={closeInfoModal} width={isDesktop ? 600 : 380}>
        <div className="flex flex-col text-center items-center gap-4 max-w-[380px] desktop:max-w-[800px]">
          <div className="text-xl desktop:text-2xl font-bold">{t('Terms & Conditions')}</div>

          <div className="text-lg desktop:text-xl font-semibold">{t('Christmas & New Year Special')}</div>

          <div className="flex flex-col text-primaryLight gap-2 [&>span]:font-normal [&>span]:text-[10px] [&>span]:desktop:text-[14px] text-left">
            <div className="text-[12px] desktop:text-lg">{t('Promotion period: Only from 21.12. to 05.01.')}</div>

            <div className="text-[12px] desktop:text-lg">{t('Minimum rental period: 1 month')}</div>

            <div className="text-[12px] desktop:text-lg">{t('Billing')}:</div>

            <span className="pl-4">{t('Months 1–4: Discount according to the tiered structure on the regular rent (plus insurance)')}</span>

            <span className="pl-4">{t('From month 5: Regular rent applies (plus insurance)')}</span>

            <div className="text-[12px] desktop:text-lg">{t('Locations & units:')}</div>

            <span className="pl-4">{t('Valid for all unit sizes and all locations, while available')}</span>

            <div className="text-[12px] desktop:text-lg">{t('Contract start:')}</div>

            <span className="pl-4">{t('Freely selectable – start date can be chosen at any time')}</span>

            <div className="text-[12px] desktop:text-lg">{t('Flexibility:')}</div>

            <span className="pl-4">
              {t('After the minimum rental period, the contract automatically extends monthly unless canceled with 14 days’ notice')}
            </span>

            <div className="text-[12px] desktop:text-lg">{t('Eligibility: For new and existing customers making a new booking')}</div>

            <div className="text-[12px] desktop:text-lg">
              {t('Combination: Cannot be combined with other promotions, vouchers, or special prices')}
            </div>

            <span>{t('The general terms and conditions of the contract apply.')}</span>
          </div>

          <Button
            containerClassName="min-w-[255px] max-w-[380px]"
            className="!bg-[#DD4742]"
            fontColor="text-white"
            fontSize={isDesktop ? 'large' : 'medium'}
            onClick={closeInfoModal}
          >
            {t('Close')}
          </Button>
        </div>
      </Modal>
    </Modal>
  );
});
